import styled, { css } from 'styled-components';

import { SliderArrowProps, SliderArrowVariants } from './types';

const variants: { [key in SliderArrowVariants]: ReturnType<typeof css> } = {
  left: css`
    left: -53px;
    transform: translateY(-50%) rotate(180deg);
  `,
  right: css`
    right: -53px;
  `
};

const SliderArrowWrapper = styled.div<SliderArrowProps>`
  opacity: 0.5;
  transition: 0.3s;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;

  &:hover {
    opacity: 1;
  }

  ${({ direction }) => variants[direction]};
`;

export default SliderArrowWrapper;
